import { render, staticRenderFns } from "./file-rocket.vue?vue&type=template&id=27e43959&scoped=true"
import script from "./file-rocket.vue?vue&type=script&lang=js"
export * from "./file-rocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e43959",
  null
  
)

export default component.exports